// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/fonts/be-vietnam-pro-v11-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/fonts/be-vietnam-pro-v11-latin-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/assets/fonts/be-vietnam-pro-v11-latin-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../src/assets/fonts/be-vietnam-pro-v11-latin-500.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../src/assets/fonts/be-vietnam-pro-v11-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../src/assets/fonts/be-vietnam-pro-v11-latin-700.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/svgs/bg-simplify-section-mobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/svgs/bg-simplify-section-desktop.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
// ─────────────────────────────────────────────────────────────────────────────
// GLOBAL STYLES
// Core stylesheet containing CSS variables, dark mode styles, base element
// styling, typography rules, utility classes, component styles, navigation,
// footer, and other repeated section styles for the entire site
// ───────────────────────────────────────────────────────────────────────────── 
*/

*,
*:before,
*:after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

:root {
  /*- Gray 950: hsl(233, 12%, 13%)
- Orange 50: hsl(13, 100%, 96%)
- Gray 50: hsl(0, 0%, 98%)*/

  --color-primary: #f3603c; /* Orange 400 */
  --color-primary-light: #f98f75; /* Orange 350 */
  --color-primary-very-light: #fff0ec; /* Orange 50 */

  --color-complementary: #242d52; /* Blue 950 */
  --color-complementary-light: #e5e9ea; /* Blue 50 */

  --color-body-text: #242d52;
  --color-gray-950: #1d1e25; /* Gray 950 */
  --color-gray-900: #343a40; /* Gray 900 */
  --color-gray-400: #8d8d8d; /* Gray 900 */
  --color-gray-50: #fafafa; /* Gray 900 */

  --color-body-text-light: #ffffff; /* White */

  --color-header-text: #242d52; /* Blue 950 */
  --color-header-text-light: #ffffff; /* White */

  --color-highlight: #f33c3c; /* Red */
  --color-highlight-light: #e5e9ea; /* Blue 50 */

  --accent: #f33c3c; /* Red */

  --color-gradient: linear-gradient (rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));

  --dark: #0f1d30;
  --secondary: #1d3557ff;

  --header-font: "Be Vietnam Pro", Arial, Helvetica, sans-serif;
  --body-font: "Be Vietnam Pro", Arial, Helvetica, sans-serif;

  /* 13px - 16px */
  --topper-font-size: clamp(0.8125rem, 1.6vw, 1rem);
  /* 32px - 40px */
  --header-font-size: clamp(2rem, 3.9vw, 2.5rem);
  --body-font-size: 1rem;

  --header-logo-scale-factor: 186; /* decreasing/increasing this value will decrease/increase max size of the header logo */
  /* 60px - 100px top and bottom */
  --section-padding: clamp(3.75rem, 7.82vw, 6.25rem) 1rem;
}

html,
body {
  font-family: var(--body-font);
  font-size: 100%; /* unsure why this is necessary */
  color: var(--color-body-text);
  position: relative;
  overflow-x: hidden;
}

.bg-image,
.bg-image-two {
  position: absolute;
  visibility: hidden;
}

@media (min-width: 48rem) {
  .bg-image {
    visibility: visible;
    top: -13.5rem;
    right: -10rem;
  }

  .bg-image-two {
    visibility: visible;
    top: 42%;
    left: -35%;
  }
}

/* Utility Classes */
.title {
  font-size: var(--header-font-size);
  font-weight: 700;
  line-height: 1.2em;
  text-align: inherit;
  max-width: 43.75rem;
  margin: 0 0 1rem 0;
  color: var(--color-header-text);
  position: relative;
}

.text {
  font-size: var(--bod-font-size);
  line-height: 1.5em;
  text-align: inherit;
  width: 100%;
  max-width: 40.625rem;
  margin: 0;
  color: var(--color-body-text);
  opacity: 50.25%;
}

.bold {
  font-weight: 700;
}

.hide-on-mobile {
  display: none;
}

/* Desktop Utility Classes */
@media only screen and (min-width: 64rem) {
  .hide-on-mobile {
    display: block;
  }

  .hide-on-desktop {
    display: none;
  }
}

/* Base Element Styles */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--header-font);
  line-height: 1.2em;
  color: var(--color-complementary);
}

p,
li,
a {
  font-size: calc(16 / 16 * 1rem);
  line-height: 1.5em;
  color: var(--color-body-text);
}

a,
button {
  &:hover {
    cursor: pointer;
  }
}

body.dark-mode {
  background-color: var(--dark);

  p,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--color-body-text-light);
  }
}

/* ******************* */
/*        FONTS        */
/* ******************* */

/* be-vietnam-pro-regular - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Be Vietnam Pro";
  font-style: normal;
  font-weight: 400;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      format("woff2"),
    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
      url(${___CSS_LOADER_URL_REPLACEMENT_1___})
      format("woff"); /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */
}
/* be-vietnam-pro-500 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Be Vietnam Pro";
  font-style: normal;
  font-weight: 500;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___})
      format("woff2"),
    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
      url(${___CSS_LOADER_URL_REPLACEMENT_3___})
      format("woff"); /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */
}
/* be-vietnam-pro-700 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Be Vietnam Pro";
  font-style: normal;
  font-weight: 700;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_4___})
      format("woff2"),
    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
      url(${___CSS_LOADER_URL_REPLACEMENT_5___})
      format("woff"); /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */
}

/* ******************* */
/*  COMPONENTS & UTILS */
/* ******************* */
@media only screen and (min-width: 0rem) {
  .button-solid {
    z-index: 1;
    position: relative;
    display: inline-block;
    background-color: var(--color-primary);
    width: auto;
    padding: 1rem 2rem;
    text-decoration: none;
    font-size: 0.8125rem;
    line-height: 1.4em;
    font-weight: bold;
    border-radius: 100vw;
    overflow: hidden;
    color: var(--color-body-text-light);
    transition: color 0.3s;
    transition-delay: 0.1s;
    text-align: center;

    &.inverted {
      background-color: var(--color-body-text-light);
      color: var(--color-primary);
    }
  }
  .button-solid:hover {
    color: #fff;
  }
  .button-solid:hover:before {
    width: 100%;
  }
  .button-solid:before {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    opacity: 1;
    display: block;
    background-color: var(--color-complementary);
    height: 100%;
    width: 0;
    transition: width 0.3s;
  }
  .button-outline {
    z-index: 1;
    position: relative;
    display: inline-block;
    width: auto;
    padding: 1rem 2rem;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 1rem;
    line-height: 1em;
    font-weight: bold;
    border: 2px solid #000;
    color: #000;
    transition: color 0.3s;
    transition-delay: 0.1s;
    text-align: center;
  }
  .button-outline:hover {
    color: #fff;
  }
  .button-outline:hover:before {
    width: 100%;
  }
  .button-outline:before {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    opacity: 1;
    display: block;
    background-color: #000;
    height: 100%;
    width: 0;
    transition: width 0.3s;
  }
}

/* ****** */
/* HEADER */
/* ****** */
header {
  width: 100%;
  position: relative;
  padding: 0 1.5rem;
  background-color: transparent;
  margin-top: 2.5625rem;
  z-index: 2;

  .container {
    width: 100%;
    max-width: calc(1280 / 16 * 1rem);
    margin: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: calc(24 / 16 * 1rem);
  }

  .logo {
    width: 40%;
    max-width: calc(var(--header-logo-scale-factor) / 16 * 1rem);
    height: 100%;
    margin: 0 auto 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;

    img {
      width: 100%;
      height: 100%;
      /* ensures the image never overflows the container. It stays contained within it's width and height and expands to fill it then stops once it reaches an edge */
      object-fit: contain;
      /* places the image to the left edge of the parent */
      object-position: left;
    }
  }

  nav ul {
    width: auto;
    min-width: 40%;
    height: 65vh;
    margin: 0;
    padding: 3rem clamp(1.75rem, 3vw, 2.5rem) 2rem 4.375rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 1.25rem;
  }

  nav li {
    list-style: none;
    margin-bottom: calc(16 / 16 * 1rem);
    &:last-of-type {
      margin-bottom: 0;
    }
    .li-link {
      font-size: calc(16 / 16 * 1rem);
      text-decoration: none;
      line-height: 1.5em;
      color: var(--color-header-text);
      cursor: pointer;
      display: inline-block;
      position: relative;

      &:before {
        /* active state underline */
        content: "";
        width: 100%;
        height: 1px;
        background-color: currentColor;
        opacity: 1;
        display: none;
        position: absolute;
        bottom: calc(-2 / 16 * 1rem);
        left: 0;
      }

      &.active {
        &:before {
          display: block;
        }
      }
    }
  }
}

/* ******************* */
/*     MOBILE MENU     */
/* ******************* */
@media only screen and (max-width: 1023.5px) {
  header {
    nav .ul-wrapper {
      height: 100vh;
      background-color: #ffffff;
      box-shadow: inset rgba(0, 0, 0, 0.2) 0px 8px 24px;
      opacity: 0;
      position: absolute;
      top: 100%;
      right: 0;
      left: auto;
      z-index: -1;
      overflow: hidden;
      transform: scaleX(0);
      transition:
        transform 0.4s,
        opacity 0.3s;
      transform-origin: top right;
    }

    nav ul {
      overflow: scroll;
    }

    nav li {
      text-align: right;
      width: 100%;
      opacity: 0;
      transform: translateX(-2.5rem);
      transition:
        transform 0.6s,
        opacity 0.9s;

      .li-link {
        font-size: clamp(1rem, 2.5vw, 1.5rem);
        line-height: 1.2em;
        display: inline-block;
        position: relative;
      }
    }

    nav li:nth-of-type(1) {
      transition-delay: 0.05s;
    }

    nav li:nth-of-type(2) {
      transition-delay: 0.1s;
    }

    nav li:nth-of-type(3) {
      transition-delay: 0.15s;
    }

    nav li:nth-of-type(4) {
      transition-delay: 0.2s;
    }

    nav li:nth-of-type(5) {
      transition-delay: 0.25s;
    }

    nav li:nth-of-type(6) {
      transition-delay: 0.3s;
    }

    nav li:nth-of-type(7) {
      transition-delay: 0.35s;
    }

    nav li:nth-of-type(8) {
      transition-delay: 0.4s;
    }

    nav li:nth-of-type(9) {
      transition-delay: 0.45s;
    }

    .hamburger {
      /* 44px - 48px */
      width: clamp(2.75rem, 6vw, 3rem);
      height: clamp(2.75rem, 6vw, 3rem);
      margin: 0 0 0 auto;
      background-color: transparent;
      border: none;
      border-radius: 0.25rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .box {
        /* 24px - 28px */
        width: clamp(1.5rem, 2vw, 1.75rem);
        /* 14px - 16px */
        height: clamp(0.875rem, 1.5vw, 1rem);
        position: relative;
      }

      .line {
        width: 100%;
        height: 4px;
        background-color: var(--color-complementary);
        transition: transform 0.5s ease;
        display: block;
        position: absolute;
      }

      .line1 {
        top: 0;
      }

      .line2 {
        top: 50%;
      }

      .line3 {
        top: 100%;
      }
    }

    .button-solid {
      display: none;
    }
  }

  header::before {
    /* black blurred overlay */
    content: "";
    width: 0%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    opacity: 0;
    display: block;
    position: absolute;
    top: 100%;
    right: 0;
    z-index: -11;
    transition:
      width 0.5s,
      opacity 0.3s;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  header.active::before {
    width: 100%;
    opacity: 1;
  }

  header.active {
    nav .ul-wrapper {
      opacity: 1;
      transform: scaleX(1);
      transition-delay: 0.2s;
    }

    nav li {
      opacity: 1;
      transform: translateX(0);
    }

    .hamburger {
      .line1 {
        transform: rotate(45deg);
        top: 50%;
      }
      .line2 {
        transform: scale(0);
      }
      .line3 {
        transform: rotate(-45deg);
        top: 50%;
      }
    }
  }
}

/* ******************* */
/* NAVIGATION DROPDOWN */
/* ******************* */
@media only screen and (max-width: 1023.5px) {
  header {
    nav li.dropdown {
      color: var(--color-body-text-light);
      position: relative;

      .li-link {
        position: relative;
      }

      .drop-icon {
        width: 0.9375rem;
        height: auto;
        position: absolute;
        top: 50%;
        right: -1.25rem;
        transform: translateY(-50%);
      }
    }
  }
}

@media only screen and (min-width: 64rem) {
  header {
    nav li.dropdown {
      position: relative;
      .li-link {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.2rem;
      }
    }

    .drop-icon {
      width: 1rem;
      height: auto;
      display: inline-block;
    }
  }
}

/* ******************* */
/*       DESKTOP       */
/* ******************* */
@media only screen and (min-width: 64rem) {
  header {
    .container {
      justify-content: space-between;
    }

    .logo {
      margin-right: 0;
    }

    padding: 0 1rem;
    .hamburger {
      display: none;
    }

    nav ul {
      width: 100%;
      height: 100%;
      padding: 0;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: clamp(1.25rem, 2.6vw, 2.25rem);
    }
    nav li {
      padding: 2rem 0;
      margin: 0;

      .li-link {
        /* 14px - 16px */
        font-size: clamp(0.875rem, 1vw, 1rem);
        line-height: 1.5em;
        text-decoration: none;
        margin: 0;
        color: var(--color-body-text);
        display: block;
        position: relative;

        &:hover {
          &:before {
            width: 100%;
          }
        }

        &.active {
          &:before {
            width: 100%;
          }
        }

        &:before {
          /* active state underline */
          width: 0%;
          height: 2px;
          background: var(--color-primary);
          display: block;
          bottom: calc(0 / 16 * 1rem);
          transition: width 0.3s;
        }
      }
    }
  }
}

/* ******************* */
/*         CTA         */
/* ******************* */

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
  #cta {
    height: 405px;
    padding: 0 1rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-repeat: no-repeat;
    background-position: left;
    background-color: var(--color-primary);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .container {
      width: 100%;
      max-width: calc(1280 / 16 * 1rem);
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      /* 48px - 64px */
      gap: clamp(3rem, 6vw, 4rem);
    }

    .content {
      /* set text align to left if content needs to be left aligned */
      text-align: center;
      width: 100%;
      display: flex;
      flex-direction: column;
      /* centers content horizontally, set to flex-start to left align */
      align-items: center;
    }

    .title {
      color: var(--color-header-text-light);
      font-size: 2.5rem;
      line-height: 1.1em;
      margin-bottom: 2.5rem;
    }

    .picture {
      height: 100%;
      width: 100%;
      display: block;
      position: absolute;
      z-index: 100;
      top: 0;
      left: 0;

      &:before {
        /* black color overlay */
        content: "";
        position: absolute;
        display: block;
        height: 100%;
        width: 100%;
        background: #000;
        opacity: 0.8;
        top: 0;
        left: 0;
        z-index: 1;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
}

@media only screen and (min-width: 64rem) {
  #cta {
    height: 220px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-position: right;
    background-size: 100%;

    .container {
      margin: 0;
    }

    .content {
      flex-direction: row;
      justify-content: space-between;
      max-width: 70rem;
    }

    .title {
      margin: 0;
      text-align: start;
      max-width: 32rem;
      letter-spacing: -0.75px;
    }
  }
}
/* ******************* */
/*       FOOTER        */
/* ******************* */

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
  #footer {
    padding: var(--section-padding);
    background-color: var(--color-gray-950);

    .container {
      width: 100%;
      /* reset on tablet */
      max-width: calc(550 / 16 * 1rem);
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      row-gap: calc(48 / 16 * 1rem);
    }

    .subscribe {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
    }

    .subscribe input {
      flex: 1;
      max-width: calc(338 / 16 * 1rem);
      padding: 1rem 1.5rem;
      border-radius: 1.375rem;
      border: none;
      height: 100%;
      line-height: 2em;
    }

    .subscribe .button-solid {
      flex: 0 0 auto;
      margin-left: 0.5rem;
      border: none;
    }

    .logo-container {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      margin: 0.5rem 0;
    }

    .logo {
      /* 210px - 240px */
      width: clamp(13.125rem, 8vw, 15rem);
      height: auto;
      display: block;
      /* 28px - 44px */
      /* margin-bottom: clamp(1.75rem, 4.17vw, 2.75rem); */
    }

    .logo-img {
      width: 100%;
      height: auto;

      &.dark {
        display: none;
      }
    }

    .text {
      color: var(--color-body-text-light);
      font-size: 0.8125rem;
      text-align: center;
    }

    .social {
      display: flex;
      justify-content: flex-start;
      gap: calc(32 / 16 * 1rem);
    }

    .social-link {
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 1;
      transition:
        transform 0.3s,
        background-color 0.3s;

      &:hover {
        background-color: var(--dark);
        transform: translateY(-0.1875rem);
      }
    }

    .social-img {
      height: 2rem;
      width: 2rem;
      display: block;
    }

    /* Navigation Links */
    .links {
      display: flex;
      flex-wrap: wrap;
      column-gap: calc(100 / 16 * 1rem);
    }

    .nav {
      padding: 0;
      margin: 0;
    }

    .nav-li {
      list-style: none;
      margin-bottom: calc(16 / 16 * 1rem);
      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .nav-link {
      font-size: calc(16 / 16 * 1rem);
      text-decoration: none;
      line-height: 1.5em;
      color: var(--color-body-text-light);
      position: relative;

      &:before {
        /* underline */
        content: "";
        width: 0%;
        height: calc(2 / 16 * 1rem);
        background: var(--color-body-text-light);
        opacity: 1;
        position: absolute;
        display: block;
        bottom: calc(-2 / 16 * 1rem);
        left: 0;
        transition: width 0.3s;
      }

      &:hover {
        &:before {
          width: 100%;
        }
      }
    }

    /* Contact Links */
    .contact {
      margin: 0;
      padding: 0;
      width: 35%;
    }

    .contact-li {
      list-style: none;
      margin-bottom: calc(0 / 16 * 1rem);
      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .contact-link {
      font-size: calc(16 / 16 * 1rem);
      text-decoration: none;
      line-height: 1.5em;
      text-align: left;
      color: var(--color-body-text-light);
      display: inline-block;

      &:hover {
        text-decoration: underline;
      }
    }

    .address {
      font-size: calc(16 / 16 * 1rem);
      margin-bottom: calc(20 / 16 * 1rem);
    }
  }
}

/* Tablet - 768px */

/* Small Desktop - 1024px */
@media only screen and (min-width: 64rem) {
  #footer {
    padding-top: calc(61 / 16 * 1rem);
    padding-bottom: calc(61 / 16 * 1rem);

    .container {
      max-width: calc(1110 / 16 * 1rem);
      height: calc(128 / 16 * 1rem);
      display: grid;
      gap: 0;
      grid-template-columns: 164px 116px 542px 272px;
      grid-template-rows: repeat(2, 1fr);
      grid-template-areas:
        "logo x links subscribe"
        "social x links copy";
    }

    .logo-container {
      width: auto;
      max-width: calc(305 / 16 * 1rem);
      grid-area: logo;
      margin: 0;
      align-self: start;
    }

    .text {
      width: 100%;
      grid-area: copy;
      align-self: flex-end;
      text-align: right;
    }

    .links {
      gap: 0;
      grid-area: links;
    }

    .nav {
      width: calc(255 / 16 * 1rem);
    }

    .nav-li {
      margin-bottom: 0.5rem;
    }

    .nav-link {
      line-height: 1.625em;
    }

    .contact {
      width: auto;
    }

    .social {
      gap: 1rem;
      grid-area: social;
      max-width: 100%;
      align-self: flex-end;
    }

    .social-link,
    .social-img {
      width: 1.25rem;
      height: 1.25rem;
    }
    .subscribe {
      display: flex;
      width: 100%;
      height: calc(44 / 16 * 1rem);
      grid-area: subscribe;
      align-self: start;
      input {
        width: 200px;
      }

      .button-solid {
        padding: 0.75rem 1.5rem;
        line-height: 1.45em;
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/root.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED;;;EAGE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE;;2BAEyB;;EAEzB,wBAAwB,EAAE,eAAe;EACzC,8BAA8B,EAAE,eAAe;EAC/C,mCAAmC,EAAE,cAAc;;EAEnD,8BAA8B,EAAE,aAAa;EAC7C,oCAAoC,EAAE,YAAY;;EAElD,0BAA0B;EAC1B,yBAAyB,EAAE,aAAa;EACxC,yBAAyB,EAAE,aAAa;EACxC,yBAAyB,EAAE,aAAa;EACxC,wBAAwB,EAAE,aAAa;;EAEvC,gCAAgC,EAAE,UAAU;;EAE5C,4BAA4B,EAAE,aAAa;EAC3C,kCAAkC,EAAE,UAAU;;EAE9C,0BAA0B,EAAE,QAAQ;EACpC,gCAAgC,EAAE,YAAY;;EAE9C,iBAAiB,EAAE,QAAQ;;EAE3B,wEAAwE;;EAExE,eAAe;EACf,sBAAsB;;EAEtB,6DAA6D;EAC7D,2DAA2D;;EAE3D,gBAAgB;EAChB,iDAAiD;EACjD,gBAAgB;EAChB,8CAA8C;EAC9C,sBAAsB;;EAEtB,+BAA+B,EAAE,wFAAwF;EACzH,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;;EAEE,6BAA6B;EAC7B,eAAe,EAAE,iCAAiC;EAClD,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,SAAS;EACT,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,wBAAwB;AACxB;;;;;;EAME,+BAA+B;EAC/B,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;;EAGE,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,6BAA6B;;EAE7B;;;;;;;;IAQE,mCAAmC;EACrC;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB,mCAAmC;AACnC;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB;;;;;oBAKkB,EAAE,wDAAwD;AAC9E;AACA,+BAA+B;AAC/B;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB;;;;;oBAKkB,EAAE,wDAAwD;AAC9E;AACA,+BAA+B;AAC/B;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB;;;;;oBAKkB,EAAE,wDAAwD;AAC9E;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,qBAAqB;IACrB,sCAAsC;IACtC,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,mCAAmC;IACnC,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;;IAElB;MACE,8CAA8C;MAC9C,2BAA2B;IAC7B;EACF;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,UAAU;IACV,cAAc;IACd,4CAA4C;IAC5C,YAAY;IACZ,QAAQ;IACR,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,UAAU;IACV,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,QAAQ;IACR,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX,WAAW;AACX,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;EACrB,UAAU;;EAEV;IACE,WAAW;IACX,iCAAiC;IACjC,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,4DAA4D;IAC5D,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;;IAEX;MACE,WAAW;MACX,YAAY;MACZ,+JAA+J;MAC/J,mBAAmB;MACnB,oDAAoD;MACpD,qBAAqB;IACvB;EACF;;EAEA;IACE,WAAW;IACX,cAAc;IACd,YAAY;IACZ,SAAS;IACT,uDAAuD;IACvD,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,mCAAmC;IACnC;MACE,gBAAgB;IAClB;IACA;MACE,+BAA+B;MAC/B,qBAAqB;MACrB,kBAAkB;MAClB,+BAA+B;MAC/B,eAAe;MACf,qBAAqB;MACrB,kBAAkB;;MAElB;QACE,2BAA2B;QAC3B,WAAW;QACX,WAAW;QACX,WAAW;QACX,8BAA8B;QAC9B,UAAU;QACV,aAAa;QACb,kBAAkB;QAClB,4BAA4B;QAC5B,OAAO;MACT;;MAEA;QACE;UACE,cAAc;QAChB;MACF;IACF;EACF;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE;IACE;MACE,aAAa;MACb,yBAAyB;MACzB,iDAAiD;MACjD,UAAU;MACV,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,UAAU;MACV,WAAW;MACX,gBAAgB;MAChB,oBAAoB;MACpB;;oBAEc;MACd,2BAA2B;IAC7B;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,WAAW;MACX,UAAU;MACV,8BAA8B;MAC9B;;oBAEc;;MAEd;QACE,qCAAqC;QACrC,kBAAkB;QAClB,qBAAqB;QACrB,kBAAkB;MACpB;IACF;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,gCAAgC;MAChC,iCAAiC;MACjC,kBAAkB;MAClB,6BAA6B;MAC7B,YAAY;MACZ,sBAAsB;MACtB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;;MAEnB;QACE,gBAAgB;QAChB,kCAAkC;QAClC,gBAAgB;QAChB,oCAAoC;QACpC,kBAAkB;MACpB;;MAEA;QACE,WAAW;QACX,WAAW;QACX,4CAA4C;QAC5C,+BAA+B;QAC/B,cAAc;QACd,kBAAkB;MACpB;;MAEA;QACE,MAAM;MACR;;MAEA;QACE,QAAQ;MACV;;MAEA;QACE,SAAS;MACX;IACF;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,SAAS;IACT,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ;;kBAEc;IACd,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;MACV,oBAAoB;MACpB,sBAAsB;IACxB;;IAEA;MACE,UAAU;MACV,wBAAwB;IAC1B;;IAEA;MACE;QACE,wBAAwB;QACxB,QAAQ;MACV;MACA;QACE,mBAAmB;MACrB;MACA;QACE,yBAAyB;QACzB,QAAQ;MACV;IACF;EACF;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE;IACE;MACE,mCAAmC;MACnC,kBAAkB;;MAElB;QACE,kBAAkB;MACpB;;MAEA;QACE,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,QAAQ;QACR,eAAe;QACf,2BAA2B;MAC7B;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE,kBAAkB;MAClB;QACE,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;MACb;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,qBAAqB;IACvB;EACF;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE;IACE;MACE,8BAA8B;IAChC;;IAEA;MACE,eAAe;IACjB;;IAEA,eAAe;IACf;MACE,aAAa;IACf;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,UAAU;MACV,mBAAmB;MACnB,2BAA2B;MAC3B,mBAAmB;MACnB,mCAAmC;IACrC;IACA;MACE,eAAe;MACf,SAAS;;MAET;QACE,gBAAgB;QAChB,qCAAqC;QACrC,kBAAkB;QAClB,qBAAqB;QACrB,SAAS;QACT,6BAA6B;QAC7B,cAAc;QACd,kBAAkB;;QAElB;UACE;YACE,WAAW;UACb;QACF;;QAEA;UACE;YACE,WAAW;UACb;QACF;;QAEA;UACE,2BAA2B;UAC3B,SAAS;UACT,WAAW;UACX,gCAAgC;UAChC,cAAc;UACd,2BAA2B;UAC3B,sBAAsB;QACxB;MACF;IACF;EACF;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB,mBAAmB;AACnB;EACE;IACE,aAAa;IACb,eAAe;IACf,yDAAqE;IACrE,4BAA4B;IAC5B,yBAAyB;IACzB,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;MACE,WAAW;MACX,iCAAiC;MACjC,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,gBAAgB;MAChB,2BAA2B;IAC7B;;IAEA;MACE,+DAA+D;MAC/D,kBAAkB;MAClB,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB,kEAAkE;MAClE,mBAAmB;IACrB;;IAEA;MACE,qCAAqC;MACrC,iBAAiB;MACjB,kBAAkB;MAClB,qBAAqB;IACvB;;IAEA;MACE,YAAY;MACZ,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,YAAY;MACZ,MAAM;MACN,OAAO;;MAEP;QACE,wBAAwB;QACxB,WAAW;QACX,kBAAkB;QAClB,cAAc;QACd,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,MAAM;QACN,OAAO;QACP,UAAU;MACZ;;MAEA;QACE,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,YAAY;QACZ,WAAW;QACX,iBAAiB;MACnB;IACF;EACF;AACF;;AAEA;EACE;IACE,aAAa;IACb,yDAAoE;IACpE,0BAA0B;IAC1B,qBAAqB;;IAErB;MACE,SAAS;IACX;;IAEA;MACE,mBAAmB;MACnB,8BAA8B;MAC9B,gBAAgB;IAClB;;IAEA;MACE,SAAS;MACT,iBAAiB;MACjB,gBAAgB;MAChB,uBAAuB;IACzB;EACF;AACF;AACA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB,mBAAmB;AACnB;EACE;IACE,+BAA+B;IAC/B,uCAAuC;;IAEvC;MACE,WAAW;MACX,oBAAoB;MACpB,gCAAgC;MAChC,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,6BAA6B;IAC/B;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,aAAa;MACb,uBAAuB;IACzB;;IAEA;MACE,OAAO;MACP,gCAAgC;MAChC,oBAAoB;MACpB,uBAAuB;MACvB,YAAY;MACZ,YAAY;MACZ,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,mBAAmB;MACnB,YAAY;IACd;;IAEA;MACE,WAAW;MACX,aAAa;MACb,uBAAuB;MACvB,mBAAmB;;MAEnB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,mCAAmC;MACnC,YAAY;MACZ,cAAc;MACd,gBAAgB;MAChB,oDAAoD;IACtD;;IAEA;MACE,WAAW;MACX,YAAY;;MAEZ;QACE,aAAa;MACf;IACF;;IAEA;MACE,mCAAmC;MACnC,oBAAoB;MACpB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,2BAA2B;MAC3B,yBAAyB;IAC3B;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;MAClB,UAAU;MACV;;6BAEuB;;MAEvB;QACE,6BAA6B;QAC7B,iCAAiC;MACnC;IACF;;IAEA;MACE,YAAY;MACZ,WAAW;MACX,cAAc;IAChB;;IAEA,qBAAqB;IACrB;MACE,aAAa;MACb,eAAe;MACf,iCAAiC;IACnC;;IAEA;MACE,UAAU;MACV,SAAS;IACX;;IAEA;MACE,gBAAgB;MAChB,mCAAmC;MACnC;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE,+BAA+B;MAC/B,qBAAqB;MACrB,kBAAkB;MAClB,mCAAmC;MACnC,kBAAkB;;MAElB;QACE,cAAc;QACd,WAAW;QACX,SAAS;QACT,2BAA2B;QAC3B,wCAAwC;QACxC,UAAU;QACV,kBAAkB;QAClB,cAAc;QACd,4BAA4B;QAC5B,OAAO;QACP,sBAAsB;MACxB;;MAEA;QACE;UACE,WAAW;QACb;MACF;IACF;;IAEA,kBAAkB;IAClB;MACE,SAAS;MACT,UAAU;MACV,UAAU;IACZ;;IAEA;MACE,gBAAgB;MAChB,kCAAkC;MAClC;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE,+BAA+B;MAC/B,qBAAqB;MACrB,kBAAkB;MAClB,gBAAgB;MAChB,mCAAmC;MACnC,qBAAqB;;MAErB;QACE,0BAA0B;MAC5B;IACF;;IAEA;MACE,+BAA+B;MAC/B,mCAAmC;IACrC;EACF;AACF;;AAEA,mBAAmB;;AAEnB,2BAA2B;AAC3B;EACE;IACE,iCAAiC;IACjC,oCAAoC;;IAEpC;MACE,iCAAiC;MACjC,6BAA6B;MAC7B,aAAa;MACb,MAAM;MACN,8CAA8C;MAC9C,kCAAkC;MAClC;;6BAEuB;IACzB;;IAEA;MACE,WAAW;MACX,gCAAgC;MAChC,eAAe;MACf,SAAS;MACT,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,eAAe;MACf,oBAAoB;MACpB,iBAAiB;IACnB;;IAEA;MACE,MAAM;MACN,gBAAgB;IAClB;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,SAAS;MACT,iBAAiB;MACjB,eAAe;MACf,oBAAoB;IACtB;;IAEA;;MAEE,cAAc;MACd,eAAe;IACjB;IACA;MACE,aAAa;MACb,WAAW;MACX,4BAA4B;MAC5B,oBAAoB;MACpB,iBAAiB;MACjB;QACE,YAAY;MACd;;MAEA;QACE,uBAAuB;QACvB,mBAAmB;MACrB;IACF;EACF;AACF","sourcesContent":["/* \n// ─────────────────────────────────────────────────────────────────────────────\n// GLOBAL STYLES\n// Core stylesheet containing CSS variables, dark mode styles, base element\n// styling, typography rules, utility classes, component styles, navigation,\n// footer, and other repeated section styles for the entire site\n// ───────────────────────────────────────────────────────────────────────────── \n*/\n\n*,\n*:before,\n*:after {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  /*- Gray 950: hsl(233, 12%, 13%)\n- Orange 50: hsl(13, 100%, 96%)\n- Gray 50: hsl(0, 0%, 98%)*/\n\n  --color-primary: #f3603c; /* Orange 400 */\n  --color-primary-light: #f98f75; /* Orange 350 */\n  --color-primary-very-light: #fff0ec; /* Orange 50 */\n\n  --color-complementary: #242d52; /* Blue 950 */\n  --color-complementary-light: #e5e9ea; /* Blue 50 */\n\n  --color-body-text: #242d52;\n  --color-gray-950: #1d1e25; /* Gray 950 */\n  --color-gray-900: #343a40; /* Gray 900 */\n  --color-gray-400: #8d8d8d; /* Gray 900 */\n  --color-gray-50: #fafafa; /* Gray 900 */\n\n  --color-body-text-light: #ffffff; /* White */\n\n  --color-header-text: #242d52; /* Blue 950 */\n  --color-header-text-light: #ffffff; /* White */\n\n  --color-highlight: #f33c3c; /* Red */\n  --color-highlight-light: #e5e9ea; /* Blue 50 */\n\n  --accent: #f33c3c; /* Red */\n\n  --color-gradient: linear-gradient (rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));\n\n  --dark: #0f1d30;\n  --secondary: #1d3557ff;\n\n  --header-font: \"Be Vietnam Pro\", Arial, Helvetica, sans-serif;\n  --body-font: \"Be Vietnam Pro\", Arial, Helvetica, sans-serif;\n\n  /* 13px - 16px */\n  --topper-font-size: clamp(0.8125rem, 1.6vw, 1rem);\n  /* 32px - 40px */\n  --header-font-size: clamp(2rem, 3.9vw, 2.5rem);\n  --body-font-size: 1rem;\n\n  --header-logo-scale-factor: 186; /* decreasing/increasing this value will decrease/increase max size of the header logo */\n  /* 60px - 100px top and bottom */\n  --section-padding: clamp(3.75rem, 7.82vw, 6.25rem) 1rem;\n}\n\nhtml,\nbody {\n  font-family: var(--body-font);\n  font-size: 100%; /* unsure why this is necessary */\n  color: var(--color-body-text);\n  position: relative;\n  overflow-x: hidden;\n}\n\n.bg-image,\n.bg-image-two {\n  position: absolute;\n  visibility: hidden;\n}\n\n@media (min-width: 48rem) {\n  .bg-image {\n    visibility: visible;\n    top: -13.5rem;\n    right: -10rem;\n  }\n\n  .bg-image-two {\n    visibility: visible;\n    top: 42%;\n    left: -35%;\n  }\n}\n\n/* Utility Classes */\n.title {\n  font-size: var(--header-font-size);\n  font-weight: 700;\n  line-height: 1.2em;\n  text-align: inherit;\n  max-width: 43.75rem;\n  margin: 0 0 1rem 0;\n  color: var(--color-header-text);\n  position: relative;\n}\n\n.text {\n  font-size: var(--bod-font-size);\n  line-height: 1.5em;\n  text-align: inherit;\n  width: 100%;\n  max-width: 40.625rem;\n  margin: 0;\n  color: var(--color-body-text);\n  opacity: 50.25%;\n}\n\n.bold {\n  font-weight: 700;\n}\n\n.hide-on-mobile {\n  display: none;\n}\n\n/* Desktop Utility Classes */\n@media only screen and (min-width: 64rem) {\n  .hide-on-mobile {\n    display: block;\n  }\n\n  .hide-on-desktop {\n    display: none;\n  }\n}\n\n/* Base Element Styles */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: var(--header-font);\n  line-height: 1.2em;\n  color: var(--color-complementary);\n}\n\np,\nli,\na {\n  font-size: calc(16 / 16 * 1rem);\n  line-height: 1.5em;\n  color: var(--color-body-text);\n}\n\na,\nbutton {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\nbody.dark-mode {\n  background-color: var(--dark);\n\n  p,\n  li,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: var(--color-body-text-light);\n  }\n}\n\n/* ******************* */\n/*        FONTS        */\n/* ******************* */\n\n/* be-vietnam-pro-regular - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Be Vietnam Pro\";\n  font-style: normal;\n  font-weight: 400;\n  src:\n    url(\"../src/assets/fonts/be-vietnam-pro-v11-latin-regular.woff2\")\n      format(\"woff2\"),\n    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n      url(\"../src/assets/fonts/be-vietnam-pro-v11-latin-regular.woff\")\n      format(\"woff\"); /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */\n}\n/* be-vietnam-pro-500 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Be Vietnam Pro\";\n  font-style: normal;\n  font-weight: 500;\n  src:\n    url(\"../src/assets/fonts/be-vietnam-pro-v11-latin-500.woff2\")\n      format(\"woff2\"),\n    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n      url(\"../src/assets/fonts/be-vietnam-pro-v11-latin-500.woff\")\n      format(\"woff\"); /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */\n}\n/* be-vietnam-pro-700 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Be Vietnam Pro\";\n  font-style: normal;\n  font-weight: 700;\n  src:\n    url(\"../src/assets/fonts/be-vietnam-pro-v11-latin-700.woff2\")\n      format(\"woff2\"),\n    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n      url(\"../src/assets/fonts/be-vietnam-pro-v11-latin-700.woff\")\n      format(\"woff\"); /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */\n}\n\n/* ******************* */\n/*  COMPONENTS & UTILS */\n/* ******************* */\n@media only screen and (min-width: 0rem) {\n  .button-solid {\n    z-index: 1;\n    position: relative;\n    display: inline-block;\n    background-color: var(--color-primary);\n    width: auto;\n    padding: 1rem 2rem;\n    text-decoration: none;\n    font-size: 0.8125rem;\n    line-height: 1.4em;\n    font-weight: bold;\n    border-radius: 100vw;\n    overflow: hidden;\n    color: var(--color-body-text-light);\n    transition: color 0.3s;\n    transition-delay: 0.1s;\n    text-align: center;\n\n    &.inverted {\n      background-color: var(--color-body-text-light);\n      color: var(--color-primary);\n    }\n  }\n  .button-solid:hover {\n    color: #fff;\n  }\n  .button-solid:hover:before {\n    width: 100%;\n  }\n  .button-solid:before {\n    z-index: -1;\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: \"\";\n    opacity: 1;\n    display: block;\n    background-color: var(--color-complementary);\n    height: 100%;\n    width: 0;\n    transition: width 0.3s;\n  }\n  .button-outline {\n    z-index: 1;\n    position: relative;\n    display: inline-block;\n    width: auto;\n    padding: 1rem 2rem;\n    text-decoration: none;\n    text-transform: uppercase;\n    font-size: 1rem;\n    line-height: 1em;\n    font-weight: bold;\n    border: 2px solid #000;\n    color: #000;\n    transition: color 0.3s;\n    transition-delay: 0.1s;\n    text-align: center;\n  }\n  .button-outline:hover {\n    color: #fff;\n  }\n  .button-outline:hover:before {\n    width: 100%;\n  }\n  .button-outline:before {\n    z-index: -1;\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: \"\";\n    opacity: 1;\n    display: block;\n    background-color: #000;\n    height: 100%;\n    width: 0;\n    transition: width 0.3s;\n  }\n}\n\n/* ****** */\n/* HEADER */\n/* ****** */\nheader {\n  width: 100%;\n  position: relative;\n  padding: 0 1.5rem;\n  background-color: transparent;\n  margin-top: 2.5625rem;\n  z-index: 2;\n\n  .container {\n    width: 100%;\n    max-width: calc(1280 / 16 * 1rem);\n    margin: auto;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: calc(24 / 16 * 1rem);\n  }\n\n  .logo {\n    width: 40%;\n    max-width: calc(var(--header-logo-scale-factor) / 16 * 1rem);\n    height: 100%;\n    margin: 0 auto 0 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n\n    img {\n      width: 100%;\n      height: 100%;\n      /* ensures the image never overflows the container. It stays contained within it's width and height and expands to fill it then stops once it reaches an edge */\n      object-fit: contain;\n      /* places the image to the left edge of the parent */\n      object-position: left;\n    }\n  }\n\n  nav ul {\n    width: auto;\n    min-width: 40%;\n    height: 65vh;\n    margin: 0;\n    padding: 3rem clamp(1.75rem, 3vw, 2.5rem) 2rem 4.375rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-end;\n    gap: 1.25rem;\n  }\n\n  nav li {\n    list-style: none;\n    margin-bottom: calc(16 / 16 * 1rem);\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n    .li-link {\n      font-size: calc(16 / 16 * 1rem);\n      text-decoration: none;\n      line-height: 1.5em;\n      color: var(--color-header-text);\n      cursor: pointer;\n      display: inline-block;\n      position: relative;\n\n      &:before {\n        /* active state underline */\n        content: \"\";\n        width: 100%;\n        height: 1px;\n        background-color: currentColor;\n        opacity: 1;\n        display: none;\n        position: absolute;\n        bottom: calc(-2 / 16 * 1rem);\n        left: 0;\n      }\n\n      &.active {\n        &:before {\n          display: block;\n        }\n      }\n    }\n  }\n}\n\n/* ******************* */\n/*     MOBILE MENU     */\n/* ******************* */\n@media only screen and (max-width: 1023.5px) {\n  header {\n    nav .ul-wrapper {\n      height: 100vh;\n      background-color: #ffffff;\n      box-shadow: inset rgba(0, 0, 0, 0.2) 0px 8px 24px;\n      opacity: 0;\n      position: absolute;\n      top: 100%;\n      right: 0;\n      left: auto;\n      z-index: -1;\n      overflow: hidden;\n      transform: scaleX(0);\n      transition:\n        transform 0.4s,\n        opacity 0.3s;\n      transform-origin: top right;\n    }\n\n    nav ul {\n      overflow: scroll;\n    }\n\n    nav li {\n      text-align: right;\n      width: 100%;\n      opacity: 0;\n      transform: translateX(-2.5rem);\n      transition:\n        transform 0.6s,\n        opacity 0.9s;\n\n      .li-link {\n        font-size: clamp(1rem, 2.5vw, 1.5rem);\n        line-height: 1.2em;\n        display: inline-block;\n        position: relative;\n      }\n    }\n\n    nav li:nth-of-type(1) {\n      transition-delay: 0.05s;\n    }\n\n    nav li:nth-of-type(2) {\n      transition-delay: 0.1s;\n    }\n\n    nav li:nth-of-type(3) {\n      transition-delay: 0.15s;\n    }\n\n    nav li:nth-of-type(4) {\n      transition-delay: 0.2s;\n    }\n\n    nav li:nth-of-type(5) {\n      transition-delay: 0.25s;\n    }\n\n    nav li:nth-of-type(6) {\n      transition-delay: 0.3s;\n    }\n\n    nav li:nth-of-type(7) {\n      transition-delay: 0.35s;\n    }\n\n    nav li:nth-of-type(8) {\n      transition-delay: 0.4s;\n    }\n\n    nav li:nth-of-type(9) {\n      transition-delay: 0.45s;\n    }\n\n    .hamburger {\n      /* 44px - 48px */\n      width: clamp(2.75rem, 6vw, 3rem);\n      height: clamp(2.75rem, 6vw, 3rem);\n      margin: 0 0 0 auto;\n      background-color: transparent;\n      border: none;\n      border-radius: 0.25rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      .box {\n        /* 24px - 28px */\n        width: clamp(1.5rem, 2vw, 1.75rem);\n        /* 14px - 16px */\n        height: clamp(0.875rem, 1.5vw, 1rem);\n        position: relative;\n      }\n\n      .line {\n        width: 100%;\n        height: 4px;\n        background-color: var(--color-complementary);\n        transition: transform 0.5s ease;\n        display: block;\n        position: absolute;\n      }\n\n      .line1 {\n        top: 0;\n      }\n\n      .line2 {\n        top: 50%;\n      }\n\n      .line3 {\n        top: 100%;\n      }\n    }\n\n    .button-solid {\n      display: none;\n    }\n  }\n\n  header::before {\n    /* black blurred overlay */\n    content: \"\";\n    width: 0%;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.6);\n    opacity: 0;\n    display: block;\n    position: absolute;\n    top: 100%;\n    right: 0;\n    z-index: -11;\n    transition:\n      width 0.5s,\n      opacity 0.3s;\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n  }\n\n  header.active::before {\n    width: 100%;\n    opacity: 1;\n  }\n\n  header.active {\n    nav .ul-wrapper {\n      opacity: 1;\n      transform: scaleX(1);\n      transition-delay: 0.2s;\n    }\n\n    nav li {\n      opacity: 1;\n      transform: translateX(0);\n    }\n\n    .hamburger {\n      .line1 {\n        transform: rotate(45deg);\n        top: 50%;\n      }\n      .line2 {\n        transform: scale(0);\n      }\n      .line3 {\n        transform: rotate(-45deg);\n        top: 50%;\n      }\n    }\n  }\n}\n\n/* ******************* */\n/* NAVIGATION DROPDOWN */\n/* ******************* */\n@media only screen and (max-width: 1023.5px) {\n  header {\n    nav li.dropdown {\n      color: var(--color-body-text-light);\n      position: relative;\n\n      .li-link {\n        position: relative;\n      }\n\n      .drop-icon {\n        width: 0.9375rem;\n        height: auto;\n        position: absolute;\n        top: 50%;\n        right: -1.25rem;\n        transform: translateY(-50%);\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 64rem) {\n  header {\n    nav li.dropdown {\n      position: relative;\n      .li-link {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 0.2rem;\n      }\n    }\n\n    .drop-icon {\n      width: 1rem;\n      height: auto;\n      display: inline-block;\n    }\n  }\n}\n\n/* ******************* */\n/*       DESKTOP       */\n/* ******************* */\n@media only screen and (min-width: 64rem) {\n  header {\n    .container {\n      justify-content: space-between;\n    }\n\n    .logo {\n      margin-right: 0;\n    }\n\n    padding: 0 1rem;\n    .hamburger {\n      display: none;\n    }\n\n    nav ul {\n      width: 100%;\n      height: 100%;\n      padding: 0;\n      flex-direction: row;\n      justify-content: flex-start;\n      align-items: center;\n      gap: clamp(1.25rem, 2.6vw, 2.25rem);\n    }\n    nav li {\n      padding: 2rem 0;\n      margin: 0;\n\n      .li-link {\n        /* 14px - 16px */\n        font-size: clamp(0.875rem, 1vw, 1rem);\n        line-height: 1.5em;\n        text-decoration: none;\n        margin: 0;\n        color: var(--color-body-text);\n        display: block;\n        position: relative;\n\n        &:hover {\n          &:before {\n            width: 100%;\n          }\n        }\n\n        &.active {\n          &:before {\n            width: 100%;\n          }\n        }\n\n        &:before {\n          /* active state underline */\n          width: 0%;\n          height: 2px;\n          background: var(--color-primary);\n          display: block;\n          bottom: calc(0 / 16 * 1rem);\n          transition: width 0.3s;\n        }\n      }\n    }\n  }\n}\n\n/* ******************* */\n/*         CTA         */\n/* ******************* */\n\n/* Mobile - 360px */\n@media only screen and (min-width: 0rem) {\n  #cta {\n    height: 405px;\n    padding: 0 1rem;\n    background-image: url(\"./assets/svgs/bg-simplify-section-mobile.svg\");\n    background-repeat: no-repeat;\n    background-position: left;\n    background-color: var(--color-primary);\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .container {\n      width: 100%;\n      max-width: calc(1280 / 16 * 1rem);\n      margin: auto;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      /* 48px - 64px */\n      gap: clamp(3rem, 6vw, 4rem);\n    }\n\n    .content {\n      /* set text align to left if content needs to be left aligned */\n      text-align: center;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      /* centers content horizontally, set to flex-start to left align */\n      align-items: center;\n    }\n\n    .title {\n      color: var(--color-header-text-light);\n      font-size: 2.5rem;\n      line-height: 1.1em;\n      margin-bottom: 2.5rem;\n    }\n\n    .picture {\n      height: 100%;\n      width: 100%;\n      display: block;\n      position: absolute;\n      z-index: 100;\n      top: 0;\n      left: 0;\n\n      &:before {\n        /* black color overlay */\n        content: \"\";\n        position: absolute;\n        display: block;\n        height: 100%;\n        width: 100%;\n        background: #000;\n        opacity: 0.8;\n        top: 0;\n        left: 0;\n        z-index: 1;\n      }\n\n      img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 64rem) {\n  #cta {\n    height: 220px;\n    background-image: url(\"assets/svgs/bg-simplify-section-desktop.svg\");\n    background-position: right;\n    background-size: 100%;\n\n    .container {\n      margin: 0;\n    }\n\n    .content {\n      flex-direction: row;\n      justify-content: space-between;\n      max-width: 70rem;\n    }\n\n    .title {\n      margin: 0;\n      text-align: start;\n      max-width: 32rem;\n      letter-spacing: -0.75px;\n    }\n  }\n}\n/* ******************* */\n/*       FOOTER        */\n/* ******************* */\n\n/* Mobile - 360px */\n@media only screen and (min-width: 0rem) {\n  #footer {\n    padding: var(--section-padding);\n    background-color: var(--color-gray-950);\n\n    .container {\n      width: 100%;\n      /* reset on tablet */\n      max-width: calc(550 / 16 * 1rem);\n      margin: auto;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      row-gap: calc(48 / 16 * 1rem);\n    }\n\n    .subscribe {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n    }\n\n    .subscribe input {\n      flex: 1;\n      max-width: calc(338 / 16 * 1rem);\n      padding: 1rem 1.5rem;\n      border-radius: 1.375rem;\n      border: none;\n      height: 100%;\n      line-height: 2em;\n    }\n\n    .subscribe .button-solid {\n      flex: 0 0 auto;\n      margin-left: 0.5rem;\n      border: none;\n    }\n\n    .logo-container {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      margin: 0.5rem 0;\n    }\n\n    .logo {\n      /* 210px - 240px */\n      width: clamp(13.125rem, 8vw, 15rem);\n      height: auto;\n      display: block;\n      /* 28px - 44px */\n      /* margin-bottom: clamp(1.75rem, 4.17vw, 2.75rem); */\n    }\n\n    .logo-img {\n      width: 100%;\n      height: auto;\n\n      &.dark {\n        display: none;\n      }\n    }\n\n    .text {\n      color: var(--color-body-text-light);\n      font-size: 0.8125rem;\n      text-align: center;\n    }\n\n    .social {\n      display: flex;\n      justify-content: flex-start;\n      gap: calc(32 / 16 * 1rem);\n    }\n\n    .social-link {\n      width: 2rem;\n      height: 2rem;\n      border-radius: 50%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n      z-index: 1;\n      transition:\n        transform 0.3s,\n        background-color 0.3s;\n\n      &:hover {\n        background-color: var(--dark);\n        transform: translateY(-0.1875rem);\n      }\n    }\n\n    .social-img {\n      height: 2rem;\n      width: 2rem;\n      display: block;\n    }\n\n    /* Navigation Links */\n    .links {\n      display: flex;\n      flex-wrap: wrap;\n      column-gap: calc(100 / 16 * 1rem);\n    }\n\n    .nav {\n      padding: 0;\n      margin: 0;\n    }\n\n    .nav-li {\n      list-style: none;\n      margin-bottom: calc(16 / 16 * 1rem);\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n    }\n\n    .nav-link {\n      font-size: calc(16 / 16 * 1rem);\n      text-decoration: none;\n      line-height: 1.5em;\n      color: var(--color-body-text-light);\n      position: relative;\n\n      &:before {\n        /* underline */\n        content: \"\";\n        width: 0%;\n        height: calc(2 / 16 * 1rem);\n        background: var(--color-body-text-light);\n        opacity: 1;\n        position: absolute;\n        display: block;\n        bottom: calc(-2 / 16 * 1rem);\n        left: 0;\n        transition: width 0.3s;\n      }\n\n      &:hover {\n        &:before {\n          width: 100%;\n        }\n      }\n    }\n\n    /* Contact Links */\n    .contact {\n      margin: 0;\n      padding: 0;\n      width: 35%;\n    }\n\n    .contact-li {\n      list-style: none;\n      margin-bottom: calc(0 / 16 * 1rem);\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n    }\n\n    .contact-link {\n      font-size: calc(16 / 16 * 1rem);\n      text-decoration: none;\n      line-height: 1.5em;\n      text-align: left;\n      color: var(--color-body-text-light);\n      display: inline-block;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    .address {\n      font-size: calc(16 / 16 * 1rem);\n      margin-bottom: calc(20 / 16 * 1rem);\n    }\n  }\n}\n\n/* Tablet - 768px */\n\n/* Small Desktop - 1024px */\n@media only screen and (min-width: 64rem) {\n  #footer {\n    padding-top: calc(61 / 16 * 1rem);\n    padding-bottom: calc(61 / 16 * 1rem);\n\n    .container {\n      max-width: calc(1110 / 16 * 1rem);\n      height: calc(128 / 16 * 1rem);\n      display: grid;\n      gap: 0;\n      grid-template-columns: 164px 116px 542px 272px;\n      grid-template-rows: repeat(2, 1fr);\n      grid-template-areas:\n        \"logo x links subscribe\"\n        \"social x links copy\";\n    }\n\n    .logo-container {\n      width: auto;\n      max-width: calc(305 / 16 * 1rem);\n      grid-area: logo;\n      margin: 0;\n      align-self: start;\n    }\n\n    .text {\n      width: 100%;\n      grid-area: copy;\n      align-self: flex-end;\n      text-align: right;\n    }\n\n    .links {\n      gap: 0;\n      grid-area: links;\n    }\n\n    .nav {\n      width: calc(255 / 16 * 1rem);\n    }\n\n    .nav-li {\n      margin-bottom: 0.5rem;\n    }\n\n    .nav-link {\n      line-height: 1.625em;\n    }\n\n    .contact {\n      width: auto;\n    }\n\n    .social {\n      gap: 1rem;\n      grid-area: social;\n      max-width: 100%;\n      align-self: flex-end;\n    }\n\n    .social-link,\n    .social-img {\n      width: 1.25rem;\n      height: 1.25rem;\n    }\n    .subscribe {\n      display: flex;\n      width: 100%;\n      height: calc(44 / 16 * 1rem);\n      grid-area: subscribe;\n      align-self: start;\n      input {\n        width: 200px;\n      }\n\n      .button-solid {\n        padding: 0.75rem 1.5rem;\n        line-height: 1.45em;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
